module.exports = __webpack_public_path__ + "static/media/slide-image-1.ab6f0865.jpg";